export function isPastTime(timeString: string): boolean {
    const [time, modifier] = timeString.split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier === 'PM' && hours < 12) hours += 12;
    if (modifier === 'AM' && hours === 12) hours = 0;

    const eventDateTime = new Date();
    eventDateTime.setHours(hours, minutes, 0, 0);

    const now = new Date();

    return eventDateTime < now;
}

export function isTodayOrInThePast(date: Date): boolean {

    const inputDate = new Date(date);
    const today = new Date();
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return inputDate.getTime() <= today.getTime();
}

export function generateSuggestions(value: string): string[] {
    const num = Number(value);
    if (Number.isNaN(num)) return [];

    const units = ['Hour', 'Day', 'Week', 'Month', 'Year'];
    return units.map(unit => `${num} ${unit}${num !== 1 ? 's' : ''}`);
}